import {ENVIRONMENT} from "@/environments/environment";

class APIConfigService {
    getUrlToISM() {
        if (['DEV'].includes(ENVIRONMENT.ENVIRONMENT)) {
            return 'apiprom'; // from local to ISM API PRO
        } else {
            return `${this.getUrlToISP()}`;
        }
    }

    getUrlToISP() {
        const env = ENVIRONMENT.ENVIRONMENT;
        let apiurl = '';
        switch (env) {
            case "DEV": // from local to API local
                apiurl = 'apidev';
                break;
            case "PRE": // to PRE from local
                apiurl = 'apipre';
                break;
            case "PRO2": // to PRO from local
                apiurl = 'apiprop';
                break;
            case "PRO": // PRO in server
                apiurl = 'api';
                break;
        }
        return apiurl;
    }
}

export default new APIConfigService();
